import { render, staticRenderFns } from "./accordian-item.vue?vue&type=template&id=7bf58334&scoped=true&"
import script from "./accordian-item.vue?vue&type=script&lang=js&"
export * from "./accordian-item.vue?vue&type=script&lang=js&"
import style0 from "./accordian-item.vue?vue&type=style&index=0&id=7bf58334&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf58334",
  null
  
)

export default component.exports